import React from 'react';

const PopupArrowIcon = ({ size = 26, rotate = 'right', ...props }) => {
  const getRotateDeg = (val) => {
    switch (val) {
      case 'up':
        return '270';
      case 'left':
        return '180';
      case 'down':
        return '90';
      default:
        return '0';
    }
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 30 30"
      style={{ transform: `rotate(${getRotateDeg(rotate)}deg)` }}
      fill="none"
      {...props}
      {...props}
    >
      <path
        d="M11.1367 24.8996L19.2867 16.7496C20.2492 15.7871 20.2492 14.2121 19.2867 13.2496L11.1367 5.09961"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PopupArrowIcon;
